export type OxygenNonDeliveryReason = {
  value: number;
  label: string;
}

export const oxygenNonDeliveryReasons: OxygenNonDeliveryReason[] = [
  {
    value: 1,
    label: 'Set up with competition'
  },
  {
    value: 2,
    label: 'Patient Refused'
  },
  {
    value: 3,
    label: 'Already on Oxygen'
  },
  {
    value: 4,
    label: 'Doctor Ordered Sleep Testing'
  },
  {
    value: 5,
    label: 'Re-Qualified'
  },
  {
    value: 7,
    label: 'Re-Qualified for Competition'
  },
  {
    value: 8,
    label: 'Non-participating provider'
  },
  {
    value: 9,
    label: 'Waiting for FTF notes'
  },
  {
    value: 10,
    label: 'Already on PAP'
  },
  {
    value: 11,
    label: 'Other'
  }
]